// extracted by mini-css-extract-plugin
export default {"propositions":"nVQyJCpeAFG9055mMHlg","proposition":"t0xEhK6UMdAz8mxb7lqn","title":"IH8QV3o24_w3OKU64SqN","itemsCenter":"jpvk5yahTQ2AJUoVfNWp"};